const styles = {
  dateHeader: { textAlign: "center", borderRight: "none" },
  leftNavigateButton: { float: "left", borderRight: "none" },
  disabledIcon: {
    color: "#c9c9c9"
  },
  buttonTransparent: {
    border: `none`,
    backgroundColor: `transparent`,
    outline: `none`
  }
};

export default styles;
